<template>
  <div id="app" class="min-h-screen bg-gray-50">
    <component :is="layoutComponent">
      <router-view />
    </component>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import DefaultLayout from '@/layouts/DefaultLayout.vue'
import MinimalLayout from '@/layouts/MinimalLayout.vue'

const route = useRoute()

const layoutComponent = computed(() => {
  const layout = route.meta.layout || 'default'
  return layout === 'default' ? DefaultLayout : MinimalLayout
})
</script>
